import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'; // 导入路由配置
import i18n from './i18n'
// import { createI18n } from 'vue-i18n';
Vue.config.productionTip = false

new Vue({
  router, // 将路由实例传递给 Vue 实例
  i18n,
  render: h => h(App),
}).$mount('#app')
